import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <div className="footer-top-bar"></div>
    <div className="footer-main">
      <div className="footer-logo-and-links">
        <div className="footer-logo">LATTICE LABS</div>
        <div className="footer-links">
          <div>
            <h4>SERVICES</h4>
            <ul>
              <li><a href="/services/digital-transformation">DIGITAL TRANSFORMATION</a></li>
              <li><a href="/services/scoping-session">SCOPING SESSION</a></li>
              <li><a href="/services/product-design">PRODUCT DESIGN PROCESS</a></li>
              <li><a href="/services/minimum-viable">MINIMUM VIABLE PRODUCT</a></li>
              <li><a href="/services/software-development">SOFTWARE DEVELOPMENT</a></li>
              <li><a href="/services/web-development">WEB DEVELOPMENT</a></li>
              <li><a href="/services/mobile-development">MOBILE DEVELOPMENT</a></li>
              <li><a href="/services/nearshore-teams">NEARSHORE TEAMS</a></li>
              <li><a href="/services/ai-ds">DATA SCIENCE</a></li>
              <li><a href="/services/ui-ux">UX/UI DESIGN</a></li>
              <li><a href="/services/qa">QUALITY ASSURANCE</a></li>
              <li><a href="/services/digital-acceleration">DIGITAL ACCELERATION</a></li>
              <li><a href="/services/code-audit">CODE AUDIT</a></li>
              <li><a href="/services/ux-audit">UX AUDIT</a></li>
            </ul>
          </div>
          <div>
            <h4>INDUSTRIES</h4>
            <ul>
              <li><a href="/portfolio/fintech">FINTECH</a></li>
              <li><a href="/portfolio/greentech">GREEN TECH</a></li>
              <li><a href="/portfolio/healthtech">HEALTHTECH</a></li>
              <li><a href="/portfolio/legaltech">LEGALTECH</a></li>
              <li><a href="/portfolio/manufacturing">MANUFACTURING</a></li>
              <li><a href="/portfolio/proptech">PROPTECH</a></li>
              <li><a href="/portfolio/retail">RETAIL</a></li>
              <li><a href="/industries">ALL INDUSTRIES</a></li>
            </ul>
          </div>
          <div>
            <h4>COMPANY</h4>
            <ul>
              <li><a href="/company/about-us">ABOUT US</a></li>
              <li><a href="/company/why-us">WHY US</a></li>
             
              <li><a href="/careers">CAREERS</a></li>
            </ul>
          </div>
         
          <div>
            <h4>CONTACT US</h4>
            <ul>
              <li><a href="mailto:info@imaginarycloud.com">info@latticelabs.com</a></li>
              <li>
               
               
              </li>
              <li className="footer-link-blue"><a href="#">SEND US A MESSAGE!</a></li>
              <li className="footer-socials">
                <a href="#"><i className="fab fa-linkedin"></i></a>
                <a href="#"><i className="fab fa-facebook"></i></a>
                <a href="#"><i className="fab fa-instagram"></i></a>
                <a href="#"><i className="fab fa-github"></i></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-divider"></div>
      <div className="footer-offices">
        <div>
          <h4>LONDON</h4>
          <span>UNITED KINGDOM</span>
          <p>
128 City Road,EC1V 2NX</p>
        </div>
        <div>
          <h4>VILNIUS</h4>
          <span>LITHUANIA</span>
          
          
          <p>Perkūnkiemio g. 13-91, LT-12114 </p>
        </div>
        
      </div>
      <div className="footer-divider"></div>
    </div>
    <div className="footer-bottom">
      <div>
        Lattice Labs © 2000-2025
      </div>
      <div>
        <a href="/company-policy">Company Policy</a> &nbsp; | &nbsp; <a href="/privacy-policy">Privacy Policy</a>
      </div>
    </div>
  </footer>
);

export default Footer;
